import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesPageHeader from '../../pages/markets/pages/options/header';
import JoinOfficialChannelsStocks from '../../pages/markets/component/join-official-channels-stocks';
import ResearchReportsAlternate from '../../pages/markets/component/research-reports-alternate';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import FuturesGraphWidget from '../../pages/markets/component/futures-graph-widget';
import { WithLazy } from '@quintype/components';
import MarketsNewsOptions from '../../pages/markets/component/markets-news-options';
import MostActiveIndexOptions from '../../pages/markets/component/most-active-index-options';
import TopOpenInterestIndexOptions from '../../pages/markets/component/top-open-interest-index-options';
import OpenInterestBreakupOptions from '../../pages/markets/component/open-interest-breakup-options';
import PutCallRatioOptions from '../../pages/markets/component/put-call-ratio-options';
import '../../pages/markets/pages/options/options.m.css';
import MailmodoNewsLetter from '../../molecules/newsletter/mailmodo-news-letter';
import LiveTvWidget from '../../collection-templates/videos-list-collection/live-tv-widget';

const OptionChainFull = (props) => {
  const [news, setNews] = useState({});
  const [marketNews, setMarketNews] = useState({});
  const queryClient = new QueryClient();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getAllNews = async () => {
      const response = await fetch('/api/v1/collections/all-news-module');
      const data = await response;
      const dataInJson = await data.json();

      setNews(dataInJson);
    };
    getAllNews();
  }, []);

  useEffect(() => {
    const getMarketNews = async () => {
      setIsLoading(true);
      const response = await fetch('/api/v1/collections/markets');
      const data = await response.json();
      setMarketNews(data);
      setIsLoading(false);
    };
    getMarketNews();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        <div styleName="background-container gap-adjustments">
          <div className="container">
            <FuturesPageHeader {...props} />
          </div>
          <div styleName="container-gap-top-alt container-gap-bottom" className="container">
            <FuturesGraphWidget />
          </div>
          <WithLazy>
            {() => (
              <div styleName="background-row" className="container">
                <div>
                  <MostActiveIndexOptions widget="index" />
                </div>
                <div styleName="active-stock-container">
                  <MostActiveIndexOptions widget="stock" />
                </div>
              </div>
            )}
          </WithLazy>
        </div>
        <WithLazy>
          {() => (
            <div styleName="major-minor-fold gap-adjustments" className="container">
              <MarketsNewsOptions newsData={marketNews} loadingStatus={isLoading} />
              <div styleName="video-newsletter-container" className="video-social-widgets">
                <LiveTvWidget />
                <MailmodoNewsLetter
                  title="All You Need To Know"
                  heading="Once Every Morning"
                  footerText1="We Promise. No Spam !"
                  footerText2="View All Newsletters"
                  page="market"
                />
              </div>
            </div>
          )}
        </WithLazy>

        <WithLazy>
          {() => (
            <div styleName="major-minor-fold gap-adjustments" className="container">
              <ResearchReportsAlternate />
              <div>
                <JoinOfficialChannelsStocks />
              </div>
            </div>
          )}
        </WithLazy>
        <WithLazy>
          {() => (
            <div styleName="background-container">
              <div styleName="gap-adjustments container-gap-top" className="container">
                <TopOpenInterestIndexOptions widget="index" />
              </div>

              <div styleName="gap-adjustments " className="container">
                <TopOpenInterestIndexOptions widget="stock" />
              </div>

              <div styleName="gap-adjustments " className="container">
                <OpenInterestBreakupOptions widget="break-up" />
              </div>

              <div styleName="gap-adjustments " className="container">
                <OpenInterestBreakupOptions widget="expiry" />
              </div>

              <div styleName="gap-adjustments " className="container">
                <PutCallRatioOptions />
              </div>

              <div styleName="gap-adjustments  container-gap-bottom" className="container">
                <FuturesAndOptionsFaq />
              </div>
            </div>
          )}
        </WithLazy>
      </>
    </QueryClientProvider>
  );
};

export default OptionChainFull;
